export const environment = {
    // employee_api_base_url: 'https://localhost:59860/api/',
    // security_api_base_url: 'https://localhost:7263/api/',
    // employee_api_base_url: 'http://api-qa-instadough.intellyit.com/api/'
    //  employee_api_base_url: 'http://dev-api.instadough.io/api/'
    employee_api_base_url: 'https://21915p.instadough.io/api/',
    security_api_base_url: 'https://31915.instadough.io/api/',
    kiosk_api_base_url: 'https://854a7.instadough.io/api/'
}
